import { supabase } from './supabase';

export const getSystemSetting = async (key, fallbackValue = null) => {
  try {
    const { data, error } = await supabase
      .from('system_settings')
      .select('value')
      .eq('key', key)
      .single();

    if (error || !data) return fallbackValue;
    return data.value;
  } catch (err) {
    console.error(`Error fetching setting ${key}:`, err);
    return fallbackValue;
  }
};
